import React from "react";
import { formatDate } from '../../slices/helper.js';

function FolderItem({ name, date, handleClick }) {
  return (
    <div className="w-100 py-1 px-3 d-flex align-items-center justify-content-between
     border-bottom cursor-pointer fs-14 user-select-none hover-bg-light" style={{height: "56px"}} onClick={handleClick}>
      <div className="d-flex align-items-center gap-1 flex-grow-1 text-truncate">
        <span class="avatar-title w-auto rounded bg-transparent text-primary fs-1">
          <i class="ri-folder-line"></i>
        </span>
        <p className="m-0 flex-grow-1 text-truncate text-select-0">{name}</p>
      </div>
      <p className='m-0 ms-3 text-nowrap'>{formatDate(date)}</p>
    </div>
  )
}

export default FolderItem;